import React from 'react';
import { ActivityIcon } from 'lucide-react';
import { useTimelineContext } from '../context/TimelineContext';
import { MODE_CONFIG } from './TimelineHeader';

export const TimelineEmptyState: React.FC = () => {
  const { selectedMode } = useTimelineContext();

  const currentModeLabel = selectedMode ? MODE_CONFIG[selectedMode]?.label : null;

  return (
    <div className="flex min-h-[200px] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-border/70 bg-muted/30 mx-6 px-6 py-10 text-center">
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted/60 text-muted-foreground">
        <ActivityIcon className="h-5 w-5" />
      </div>
      <p className="text-sm font-medium text-foreground">No timeline entries</p>
      <p className="text-xs text-muted-foreground">
        {currentModeLabel
          ? `There's no activity for ${currentModeLabel}.`
          : "No activity recorded for this record yet."}
      </p>
    </div>
  );
};
